<template>
  <div class="hsHeader2 w100pc fixed">
    <div class="headerTitle">{{ pageName }}</div>
    <div class="shipInquiry" @click="JumpshipInquiry">船只查询</div>
    <div class="search">
      <van-search
        v-model="value"
        shape="round"
        background="#fff"
        placeholder="搜索业务名称或船名"
        @search="onSearch"
        @clear="onSearch"
        show-action
      >
        <template #action>
          <div class="searchSlot" @click="onSearch">搜索</div>
        </template>
      </van-search>
    </div>
    <ul class="flex jc-sa tabs menuList">
      <li
        :class="['menuItem', , activeIndex === index ? 'active' : '']"
        v-for="(menu, index) in menuList"
        :key="`${menu.component}${index}`"
      >
        <div
          :to="menu.component"
          :class="['f20']"
          @click="goItem(menu.component, index)"
        >
          <p class="mt-5 f12 text">{{ menu.text }}</p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "hsHeader2",
  props: {
    keyWords: String,
    component: String,
    pageName: String,
    menuName: String,
  },
  data() {
    return {
      value: "",
      menuLAllist: {
        dispatchOrder: [
          {
            component: "dispatchUnreciveOrder",
            text: "维修单",
          },
          {
            component: "dispatchReciveOrder",
            text: "已完成",
          },
        ],
      },
      currentRole: localStorage.getItem("role"),
      activeIndex: 0,
    };
  },
  watch: {},
  computed: {
    menuList() {
      console.log(this.menuName);
      this.$emit(
        "update:component",
        this.menuLAllist[this.menuName][0].component
      );
      return this.menuLAllist[this.menuName];
    },
  },
  methods: {
    JumpshipInquiry() {
      this.$router.push({
        path: "/shipInquiry",
      });
    },
    onSearch() {
      this.$emit("update:keyWord", this.value);
    },
    goItem(path, index) {
      this.activeIndex = index;
      this.value = "";
      this.$emit("update:keyWord", "");
      this.$emit("update:component", path);
    },
  },
  mounted() {},
};
</script>

<style lang="less" scope>
.hsHeader2 {
  background-color: #44b1f9;
  height: 140px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding-top: 15px;
  z-index: 3;
  .headerTitle {
    font-size: 16px;
    text-align: center;
    line-height: 25px;
    margin-bottom: 15px;
    height: 25px;
    color: #fff;
  }
  .shipInquiry {
    position: absolute;
    right: 15px;
    top: 15px;
    border-radius: 4px;
    background-color: #0a27f9;
    color: #fff;
    padding: 6px 10px;
    font-size: 12px;
  }
  .search {
    background-color: #44b1f9;
    padding: 0 15px;
    margin-bottom: 17px;
  }
  .tabs {
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
  }
  .menuItem {
    width: 90px;
    // background-color: rgba(0,0,0,);
    padding: 10px 0;
    position: relative;
    &.active {
      &::after {
        content: "";
        display: block;
        width: 40px;
        height: 2px;
        position: absolute;
        bottom: 0;
        left: 50%;
        margin-left: -20px;
        background-color: #fff;
      }
    }
    .text {
      font-size: 13px;
      text-align: center;
      color: #fff;
    }
  }
}
</style>
<style lang="less">
.hsHeader2 {
  .van-search {
    padding: 0;
    padding-right: 3px;
    border-radius: 15px;
  }
  .van-search__action {
    width: 65px;
    height: 28px;
    background: #44b1f9;
    border-radius: 28px;
    text-align: center;
    line-height: 28px;
    color: #fff;
    padding: 0;
  }
}
</style>